/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import Image from 'global/Image';
import Text from '@deprecated-ui/common/Text';
import Popover from '@deprecated-ui/common/Popover';
import color from '@deprecated-ui/_style/color';
import { Tooltip } from 'antd';
import useTooltip from 'hooks/useTooltip';
import { useEffect, useState } from 'react';
import CommentAnalytics from 'features/stream/analytics/CommentAnalytics';
import { ComposeCommentSetting } from '../styled';
import CommentSettingPopover from './CommentSettingPopover';
import { CommenterState } from '../types';
import { COMMENT_SETTING_LIST } from '../constants';

const LS_TOOLTIP_COMMENT_SETTING = 'tooltipCommentSettings';
const commentSettingTooltipTitle = 'Atur siapa yang boleh berkomentar';
const commentSettingTooltipText =
  'Pilih siapa yang bisa berkomentar di postingan kamu. Pilihan hanya berlaku untuk postingan ini.';

interface CommentSettingProps {
  commenter: CommenterState;
  zIndex: number;
  onChangeCommenter: (data: CommenterState) => void;
}

function CommentSetting({
  commenter,
  zIndex,
  onChangeCommenter,
}: CommentSettingProps) {
  const [visible, setVisible] = useState(false);
  const { showTooltip, onCloseTooltip } = useTooltip(
    LS_TOOLTIP_COMMENT_SETTING,
  );

  const handleChangeCommenter = (data: CommenterState) => {
    onChangeCommenter(data);
    setVisible(false);
    CommentAnalytics.Action.ChooseComment(data.label);
  };

  const handleVisibleChange = (show) => {
    setVisible(show);
  };

  const handleClickCommentSetting = () => {
    setVisible(!visible);
    CommentAnalytics.Action.CommentInfo();
  };

  useEffect(() => {
    CommentAnalytics.Navigate.ViewPage();
  }, []);

  return (
    <Popover
      visible={visible}
      content={
        <CommentSettingPopover
          commenter={commenter}
          commentSettingList={COMMENT_SETTING_LIST}
          onChangeCommenter={handleChangeCommenter}
        />
      }
      title={null}
      onVisibleChange={handleVisibleChange}
      trigger="click"
      placement="bottomLeft"
      zIndex={zIndex}
    >
      <Tooltip
        placement="right"
        title={
          <div onClick={onCloseTooltip}>
            <Text
              color={color.light}
              family="bold"
              size="12px"
              // @ts-expect-error
              mb="8px"
              height="18px"
            >
              {commentSettingTooltipTitle}
            </Text>
            <Text color={color.light} size="12px">
              {commentSettingTooltipText}
            </Text>
          </div>
        }
        trigger="click"
        visible={showTooltip}
        onVisibleChange={() => onCloseTooltip()}
        overlayClassName="tooltip-overlay-green"
        overlayInnerStyle={{
          background: color.primary,
          width: '295px',
          padding: '12px',
        }}
      >
        <ComposeCommentSetting onClick={handleClickCommentSetting}>
          <Image src={`icon/${commenter.icon}`} width="12" height="12" />
          {/* @ts-expect-error */}
          <Text ml="4px" mr="6px" size="11px" color={color.highgray}>
            {commenter.label} can comment
          </Text>
          <Image
            src="icon/compose-settings/arrow-down.svg"
            width="12"
            height="12"
          />
        </ComposeCommentSetting>
      </Tooltip>
    </Popover>
  );
}

export default CommentSetting;
